import MDBox from "components/MDBox"
import MDButton from "components/MDButton";
import TableSkeleton from "components/TableSkeleton";
import { useEffect, useMemo, useState } from "react"
import { useMaterialUIController, setLoading } from "context";
import { useForm } from "react-hook-form";
import DataTable from "examples/Tables/DataTable";
import permissions from "permissions";
import { CircularProgress } from "@mui/material";
import { FinishedProductMasterAPI } from "api/FinishedProductMasterAPI";


export default function FinishedProductMasterTable(props) {

  const [finishedProductMaster, setFinishedProductMaster] = useState([]);
  const [controller, dispatch] = useMaterialUIController();
  const { user, loading, admin } = controller;
  const { handleSubmit, formState: { isSubmitting } } = useForm();
  const { handleAlert } = props

  const currencyformatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
  });

  const numberFormater = new Intl.NumberFormat();

  const renderFinishedProductMaster = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Producto", accessor: "codigo", align: "right" },
      { Header: "Nombre Linea", accessor: "nombre_linea", align: "left", },
      { Header: "Linea", accessor: "linea", align: "left", },
    ];

    finishedProductMaster?.map((element) => {
      rows = [...rows,
      {
        codigo: element.codigo,
        nombre_linea: element.nombre_linea,
        linea: element.linea,
      }]
    });

    return (<DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
    );
  }, [finishedProductMaster])


  const getFinishedProductMaster = () => {
    setLoading(dispatch, true)
    return FinishedProductMasterAPI.index(true)
      .then(response => {
        setFinishedProductMaster(response.finished_product_master)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }


  return (
    <MDBox>
      <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', p: 3 }} component="form" role="form" onSubmit={handleSubmit(getFinishedProductMaster)}>
        {(user?.permissions?.includes(permissions.product_arrays[1]) || user?.role === admin) && (
          <MDButton type="submit" variant="gradient" color="info" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Consultar Maestro Producto Terminado'}
          </MDButton>
        )}
      </MDBox>
      <MDBox>
        {loading ? <TableSkeleton></TableSkeleton> : renderFinishedProductMaster}
      </MDBox>
    </MDBox>
  )

}